import { render, staticRenderFns } from "./addHousekeepingType.vue?vue&type=template&id=7030441b&scoped=true"
import script from "./addHousekeepingType.vue?vue&type=script&lang=js"
export * from "./addHousekeepingType.vue?vue&type=script&lang=js"
import style0 from "./addHousekeepingType.vue?vue&type=style&index=0&id=7030441b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7030441b",
  null
  
)

export default component.exports